module.exports = __webpack_public_path__ + "static/media/krx-keyvisualbg.d2af8bc0.jpg";